export default __webpack_public_path__ + "5e0cbc7d99ad3aca3b499bc218fe33a4.svg";